import { api } from "utils";
import { API_ENDPOINTS } from "utils";

export const refreshToken = async () => {
  console.log("Attempting to refresh token");
  const refreshToken = localStorage.getItem("refresh_token");
  const body = {
    refresh_token: refreshToken,
  };
  const response = await api.post(API_ENDPOINTS.TOKEN_REFRESH, body);

  const { access_token } = response.data;
  localStorage.setItem("access_token", access_token);
  // axiosRefreshToken.defaults.headers.common[
  //   "Authorization"
  // ] = `Bearer ${access_token}`;

  console.log("Token refreshed successfully");

  return access_token;
};
